import axios from "axios";
import app from "../_app";
import {toggleMicrocart, updateCartCount} from "./microcart";
import {toggleAddedToCart} from "./added-to-cart";

const quantityControls = [...document.querySelectorAll('.js-quantity-control')];

export const quantityControlInit = quantityControl => {
    if (!quantityControl.hasAttribute('data-init')) {
        const min = quantityControl.querySelector('.js-quantity-control-min');
        const plus = quantityControl.querySelector('.js-quantity-control-plus');
        const input = quantityControl.querySelector('.js-quantity-control-input');
        const remove = quantityControl.querySelector('.js-quantity-remove');

        /**
         * Preventing going over the max. quantity
         */
        input.addEventListener('keyup', () => {
            if (input.value > parseInt(input.max)) {
                input.value = parseInt(input.max);
                updateQuantityInCart();
            }else {
                updateQuantityInCart();
            }
        })

        /**
         * Minus button
         */
        min.addEventListener('click', () => {

            let currentValue = parseInt(input.value);

            if (currentValue > 1) {
                input.value = currentValue - 1;
                updateQuantityInCart();
            }else if(currentValue == 1) {
                input.value = 0;
                updateQuantityInCart();
                quantityControl.closest('.microcart-product').remove();
            }
        });

        /**
         * Plus button
         */
        plus.addEventListener('click', () => {
            let currentValue = parseInt(input.value);
            input.value = currentValue + 1;
            updateQuantityInCart(currentValue);
        });

        if(remove) {
            remove.addEventListener('click', () => {
                input.value = 0;
                updateQuantityInCart();
                input.closest('.microcart-product').style.opacity = '.4';
                setTimeout(() => {
                    remove.closest('.microcart-product').remove();
                }, 250);
            });
        }


        /*
         * Handle cart change
         */
        const updateQuantityInCart = (currentValue) => {

            const $errorMessage = input.closest('.js-cart-item').querySelector(".js-addtocart-error");

            if (parseInt(input.value) === 0) {

                input.closest('.js-cart-item').style.opacity = '.4';

                axios
                    .post("/cart/change.js", {
                        id: input.dataset.key,
                        quantity: input.value,
                    })
                    .then(function (response) {
                        min.disabled = false;
                        plus.disabled = false;
                    })
                    .catch(function (error) {
                        const errorMessage = error.response.data;
                        $errorMessage.innerHTML = '<div class="pb-3">' + errorMessage.message + '</div>';
                    });

                updateCartCount();
                input.closest('.js-cart-item').style.opacity = '0';
                input.closest('.js-cart-item').remove();

            } else {

                input.closest('.js-cart-item').style.opacity = '.4';
                input.closest('.js-cart-item').style.pointerEvents = 'none';

                axios
                    .post("/cart/change.js", {
                        id: input.dataset.key,
                        quantity: input.value,
                    })
                    .then(function (response) {
                        min.disabled = false;
                        plus.disabled = false;

                        updateCartCount();
                        input.closest('.js-cart-item').style.opacity = '1';
                        input.closest('.js-cart-item').style.pointerEvents = 'initial';
                    }).then(function (response) {
                        toggleAddedToCart();
                    })
                    .catch(function (error) {
                        const errorMessage = error.response.data;
                        $errorMessage.innerHTML = '<div class="pb-3 text--action">' + app.translationHelper('cart.not-more-than-stock') + '</div>';
                        input.closest('.js-cart-item').style.opacity = '1';
                        input.closest('.js-cart-item').style.pointerEvents = 'initial';
                        input.value = currentValue;
                    });

            }
        }

        quantityControl.setAttribute('data-init', true);
    }
}
quantityControls.map(quantityControlInit);
